import { render, staticRenderFns } from "./StrategyInfo.vue?vue&type=template&id=06309501&"
import script from "./StrategyInfo.vue?vue&type=script&lang=js&"
export * from "./StrategyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports